<!-- eslint-disable vue/no-side-effects-in-computed-properties -->
<template>
  <nav
    class="fixed top-0 h-14 z-50 w-full bg-white border-gray-200 dark:bg-bgLightDark"
  >
    <!--in ltr change lg:pr-3 to lg:pl-3-->
    <div class="px-3 py-1 lg:px-5 lg:pr-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center justify-start">
          <div class="flex flex-col my-2">
            <a
              href="/purchase-list"
              class="flex text-xl dark:text-textWhite"
              id="darkModeToggle"
            >
              <!-- <img src="/assets/image/kcStore.png" alt="" class="w-16 lg:w-20 mx-3"> -->
              <i class="fa-solid fa-chevron-right my-auto mx-2"></i>
              {{ $t("app_name") }}
            </a>
          </div>
          <div class="w-10"></div>
          <div class="dark:text-white flex items-center gap-2">
            <span>{{ $t("dolar_price") }} :</span>
            <input
              type="text"
              inputmode="decimal"
              autocomplete="off"
              :value="String(pu_main_currency_price ?? 0)"
              @input="onRootDecimalLocaleInput($event, 'pu_main_currency_price')"
              class="bg-white dark:bg-bgFullDark border border-gray-300 dark:border-gray-600 text-textBlack1 dark:text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-24 p-1.5"
            />
          </div>
        </div>
        <div class="flex items-center">
          <!-- Calculator Button -->
          <div class="mx-2">
            <button
              @click="openCalculator"
              type="button"
              class="flex relative text-sm rounded-full text-gray-600 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400"
              title="Calculator"
            >
              <span class="sr-only">Calculator</span>
              <i class="fa-solid fa-calculator text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <div
    class="mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl"
  >
    <div class="flex mb-4 justify-between">
      <p class="font-semibold text-xl text-textBlack dark:text-textWhite mx-3">
        {{ $t("new_purchase") }}
      </p>
      <div>
        <label
          for="boxType"
          class="block mb-1 text-sm text-textBlack1 dark:text-textWhite1"
          >{{ $t("currency_invoice_type") }}</label
        >
        <button
          id="boxType"
          class="bg-white border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-32 p-1.5 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          @click="changeCurrencyType"
        >
          <i
            class="fa-solid fa-arrows-rotate text-primaryColor mx-1 text-sm"
          ></i>
          <span class="mx-1" v-show="cur_id == 1">{{ $t("dinar") }}</span>
          <span class="mx-1" v-show="cur_id == 2">{{ $t("dollar") }}</span>
        </button>
      </div>
    </div>
    <div class="md:flex">
      <div class="w-full md:w-5/12 flex flex-col py-3 mx-auto md:mx-0">
        <div
          class="flex bg-white dark:bg-bgMeduimDark rounded-2xl p-3 w-full overflow-x-auto space-x-2 whitespace-nowrap mb-4"
        >
          <BaseInput
            :modelValue="$store.state.new_purchase.searchPos"
            @update:modelValue="handleSearchInput"
            :placeholder="$t('search_item')"
            :prefixIcon="'fa-solid fa-search'"
            class="w-full"
          />

          <div class="w-6"></div>

          <form @submit="enterBarcode">
            <BaseInput
              v-model="barcode"
              :placeholder="$t('barcode')"
              :prefixIcon="'fa-solid fa-barcode'"
              class="w-full"
            />
          </form>
        </div>
        <!-- Categories Dropdown -->
        <h2
          id="accordion-color-heading-categories"
          :class="
            isShowCategories ? 'border-primaryColor text-blue-600' : ''
          "
        >
          <button
            type="button"
            class="flex bg-slate-100 dark:bg-bgFullDark items-center justify-between w-full px-4 py-2 font-medium text-right text-textBlack1 dark:text-textWhite1 border-l-0 border-r-0 border border-gray-300 dark:border-gray-600 hover:border-primaryColor"
            @click="isShowCategories = !isShowCategories"
          >
            <span>{{ $t("items_categorys") }}</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 rotate-180 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h2>
        <div
          class="flex flex-wrap gap-2 bg-white dark:bg-bgMeduimDark rounded-2xl p-3 w-full overflow-x-auto space-x-2 whitespace-nowrap mb-4"
          v-if="isShowCategories"
        >
          <button
            :class="
              'px-3 py-1 text-sm bg-white dark:bg-bgMeduimDark text-textBlack2 dark:text-textWhite3 rounded-xl border ' +
              (this.$store.state.new_purchase.ca_id == ''
                ? 'border-primaryColor dark:border-primaryColor'
                : 'border-gray-300 dark:border-gray-600')
            "
            @click="this.$store.state.new_purchase.ca_id = ''"
          >
            {{ $t("all") }}
          </button>
          <button
            :class="
              'px-3 py-1 text-sm bg-white dark:bg-bgMeduimDark text-textBlack2 dark:text-textWhite3 rounded-xl border ' +
              (this.$store.state.new_purchase.ca_id == category.ca_id
                ? 'border-primaryColor dark:border-primaryColor'
                : 'border-gray-300 dark:border-gray-600')
            "
            v-for="(category, index) in this.$store.state.item_category
              .categorys"
            :key="index"
            @click="this.$store.state.new_purchase.ca_id = category.ca_id"
          >
            {{ category.ca_name }}
          </button>
        </div>

        <!-- Items Grid -->
        <h2
          id="accordion-color-heading-items"
          :class="
            isShowItems ? 'border-primaryColor text-blue-600' : ''
          "
        >
          <button
            type="button"
            class="flex bg-slate-100 dark:bg-bgFullDark items-center justify-between w-full px-4 py-2 font-medium text-right text-textBlack1 dark:text-textWhite1 border-l-0 border-r-0 border border-gray-300 dark:border-gray-600 hover:border-primaryColor"
            @click="isShowItems = !isShowItems"
          >
            <span>{{ $t("itemss") }}</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 rotate-180 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h2>
        <div
          class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 pb-10"
          v-if="isShowItems"
        >
          <!-- item 1-->
          <div
            :class="
              'flex flex-col p-2 bg-white dark:bg-bgMeduimDark rounded-2xl items-center shadow-sm p-2 cursor-pointer ' +
              (checkHowMuchItemInCard(item.i_id) != 0
                ? 'border border-primaryColor dark:border-primaryColor'
                : 'border-gray-300 dark:border-gray-600')
            "
            v-for="(item, index) in filterItemsPos"
            :key="index"
          >
            <div class="mb-1">
              <button
                type="button"
                @click="removeItem(item.i_id)"
                class="text-left mb-1"
                v-if="checkHowMuchItemInCard(item.i_id) != 0"
              >
                <i
                  class="fa-solid fa-trash text-center p-1 w-6 h-6 text-xs bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto my-auto"
                ></i>
              </button>
              <a
                class="text-left mb-1 mx-1"
                :href="'item-detail/' + item.i_id"
                target="_blank"
              >
                <i
                  class="fa-solid fa-eye text-center p-1 w-6 h-6 text-xs bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto my-auto"
                ></i>
              </a>
            </div>
            <img
              :src="file_url + item.i_image"
              alt=""
              class="mb-1 rounded-xl h-24 cursor-pointer"
              @click="addItemToPurchase(item)"
              v-if="item.i_image != '' && item.i_image != null"
            />

            <img
              src="../../assets/image/image_not_found.png"
              alt=""
              class="mb-1 rounded-xl h-24 cursor-pointer"
              @click="addItemToPurchase(item)"
              v-if="item.i_image == '' || item.i_image == null"
            />
            <p
              class="text-textBlack1 dark:text-textWhite1 text-sm text-center cursor-pointer"
              @click="addItemToPurchase(item)"
            >
              {{ item.i_name }}
            </p>
            <p
              class="text-textBlack2 dark:text-textWhite2 cursor-pointer"
              @click="addItemToPurchase(item)"
            >
              {{ $t("cost") }} : {{ formatNumber(item.i_cost_price) }}
              {{ this.$t(item.currency.cur_name) }}
            </p>
            <p
              class="text-textBlack2 dark:text-textWhite2 cursor-pointer"
              @click="addItemToPurchase(item)"
            >
              {{ $t("sale_tak") }} : {{ formatNumber(item.i_sale_price) }}
              {{ this.$t(item.currency.cur_name) }}
            </p>
            <p
              class="text-textBlack2 dark:text-textWhite2 cursor-pointer"
              @click="addItemToPurchase(item)"
            >
              {{ $t("sale_jwmla") }} :
              {{ formatNumber(item.i_sale_price_jwmla) }}
              {{ this.$t(item.currency.cur_name) }}
            </p>

            <p
              class="text-textBlack2 dark:text-textWhite2 cursor-pointer"
              @click="addItemToPurchase(item)"
            >
              {{ $t("suplier") }} :
              {{ item.suplier != null ? item.suplier.su_name : "" }}
            </p>
            <span
              v-show="checkHowMuchItemInCard(item.i_id) != 0"
              class="bg-green-500 px-3 py-2 text-white rounded-full text-xs mt-2"
              @click="addItemToPurchase(item)"
            >
              {{ checkHowMuchItemInCard(item.i_id) }}
            </span>
          </div>
        </div>
        <center>
          <span
            v-show="filterItemsPos.length == 0 && isLoadingData == false"
            class="text-textBlack1 dark:text-white"
          >
            {{ $t("no_item_found") }}
          </span>
        </center>
        <center>
          <img
            src="../../assets/loading.webp"
            style="width: 70px; height: 70px"
            v-show="isLoadingData"
          />
        </center>
      </div>

      <div class="w-4"></div>

      <div
        class="w-full md:w-7/12 my-3 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl mb-20 md:mb-14 mx-auto md:mx-0"
      >
        <form action="">
          <!--sale extra information-->

          <div id="accordion-color">
            <h2
              id="accordion-color-heading-1"
              :class="isShowDetail ? 'border-primaryColor text-blue-600' : ''"
            >
              <button
                type="button"
                class="flex bg-slate-100 dark:bg-bgFullDark items-center justify-between w-full px-4 py-2 font-medium text-right text-textBlack1 dark:text-textWhite1 border-l-0 border-r-0 border border-gray-300 dark:border-gray-600 hover:border-primaryColor"
                @click="isShowDetail = !isShowDetail"
              >
                {{ $t("detail") }}
                <svg
                  data-accordion-icon
                  class="w-3 h-3 rotate-180 shrink-0"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5 5 1 1 5"
                  />
                </svg>
              </button>
            </h2>

            <!-- extra sale information-->
            <div
              id="accordion-color-body-1"
              aria-labelledby="accordion-color-heading-1"
              v-show="isShowDetail"
            >
              <div class="p-5 grid grid-cols-2 gap-x-3">
                <DropdownInput
                  v-model="bo_id"
                  :label="$t('box')"
                  :placeholder="$t('choose_box_that_money_get_out')"
                  :rules="rules_dropdown"
                  :items="convertToListIdValueBoxes"
                  :isError="
                    checkRulesIsError(bo_id, 'add', this.rules_dropdown).isError
                  "
                  :errorMsg="
                    checkRulesIsError(bo_id, 'add', this.rules_dropdown)
                      .errorMsg
                  "
                  linkDrop="/all-box"
                />
                <div>
                <DropdownInput 
  v-model="su_id"
  :label="$t('suplier')"
  :placeholder="$t('choose_suplier_that_sell_to_you')"
  :rules="rules_dropdown"
  :items="convertToListIdValueSupliers"
  :isError="checkRulesIsError(su_id, 'add', rules_dropdown).isError"
  :errorMsg="checkRulesIsError(su_id, 'add', rules_dropdown).errorMsg"
  :call="getSuplierDebt"
  linkDrop="/suplier"
/>

                  <div style="margin-top:-40px;margin-bottom:4px"     v-show="isShowDebts">
                    <span
                      v-show="isShowDebts"
                      class="text-sm text-textBlack2 dark:text-textWhite2"
                      >{{ $t("total_debt_dinar") }} :
                      {{ formatNumber(beforeDebtIQD) }}
                    </span>
                    <div class="w-2"></div>
                    <span
                      v-show="isShowDebts"
                      class="text-sm text-textBlack2 dark:text-textWhite2"
                      >{{ $t("total_debt_dollar") }} :
                      {{ formatNumber(beforeDebtUSD) }}
                    </span>
                  </div>
                </div>

                <BaseInput
                  v-model="created_at"
                  type="date"
                  :label="$t('purchase_date')"
                  :placeholder="$t('purchase_date')"
                  :rules="no_rule"
                  :isError="
                    checkRulesIsError(created_at, 'add', this.no_rule).isError
                  "
                  :errorMsg="
                    checkRulesIsError(created_at, 'add', this.no_rule).errorMsg
                  "
                />
                <BaseInput
                  v-model="pu_wasl_company"
                  :label="$t('purchase_invoice_number')"
                  :placeholder="$t('purchase_invoice_number')"
                  :rules="no_rule"
                  :isError="
                    checkRulesIsError(pu_wasl_company, 'add', this.no_rule)
                      .isError
                  "
                  :errorMsg="
                    checkRulesIsError(pu_wasl_company, 'add', this.no_rule)
                      .errorMsg
                  "
                />
                <TextAreaInput
                  v-model="pu_note"
                  :label="$t('note')"
                  :placeholder="$t('note')"
                  :rules="no_rule"
                  :isError="
                    checkRulesIsError(pu_note, 'add', this.no_rule).isError
                  "
                  :errorMsg="
                    checkRulesIsError(pu_note, 'add', this.no_rule).errorMsg
                  "
                />
                <div>
                  <label
                    for="currency"
                    class="block mb-2 text-base font-medium text-textBlack1 dark:text-textWhite1"
                    >{{ $t("do_you_want_print_right_after_purchase") }}</label
                  >
                  <div class="flex mx-4 mt-4">
                    <div class="flex items-center ml-4">
                      <input
                        id="inline-radio11"
                        type="radio"
                        value="1"
                        checked="true"
                        v-model="isPrint"
                        name="inline-radio-group1"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        @change="printStatus"
                      />
                      <label
                        for="inline-radio"
                        class="mr-2 text-base font-medium text-gray-900 dark:text-gray-300"
                        >{{ $t("cashier") }}</label
                      >
                    </div>
                    <div class="flex items-center ml-4">
                      <input
                        id="inline-3-radio11"
                        type="radio"
                        value="3"
                        v-model="isPrint"
                        name="inline-radio-group1"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        @change="printStatus"
                      />
                      <label
                        for="inline-radio"
                        class="mr-2 text-base font-medium text-gray-900 dark:text-gray-300"
                        >{{ $t("a4") }}</label
                      >
                    </div>
                    <div class="flex items-center ml-4">
                      <input
                        id="inline-2-radio11"
                        type="radio"
                        value="2"
                        v-model="isPrint"
                        @change="printStatus"
                        name="inline-radio-group1"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        for="inline-2-radio"
                        class="mr-2 text-base font-medium text-gray-900 dark:text-gray-300"
                        >{{ $t("no") }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--table-->
          <div class="relative overflow-x-auto mt-10 mb-6 overflow-y-auto">
            <!--in ltr change (text-right to text-left)-->
            <table class="w-full text-right text-gray-500 dark:text-gray-400">
              <thead
                class="text-xs text-gray-600 border-l-0 border-r-0 border border-gray-300 dark:border-gray-600 uppercase bg-slate-100 dark:bg-bgFullDark dark:text-gray-400"
              >
                <tr>
                  <th scope="col" class="px-2 py-1">{{ $t("item_name") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("barcode") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("quantity") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("bonus") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("cost") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("discount") }}</th>
                  <!--   <th scope="col" class="px-2 py-1">{{ $t("sale_price") }}</th>-->
                  <th scope="col" class="px-2 py-1">{{ $t("final_price") }}</th>
                  <th scope="col" class="px-2 py-1">{{ $t("actions") }}</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr
                  class="bg-white text-textBlack border-b dark:bg-bgLightDark dark:text-textWhite2 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-bgFullDark"
                  v-for="(item, index) in purchase_items"
                  :key="index"
                >
                  <td class="px-2 py-2">
                    {{ item.i_name }}
                  </td>
                  <td class="px-2 py-2">
                    {{ item.i_barcode }}
                  </td>
                  <td class="px-2 py-2">
                    <input
                      type="text"
                      inputmode="numeric"
                      autocomplete="off"
                      :ref="`quantity-input-${item.i_id}`"
                      class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-14 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      :value="String(item.pui_quantity ?? 0)"
                      @input="onPurchaseLineQtyLocaleInput($event, item)"
                    />
                  </td>
                  <td class="px-2 py-2">
                    <input
                      type="text"
                      inputmode="numeric"
                      autocomplete="off"
                      class="bg-slate-100 border border-green-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-14 p-2 dark:bg-bgFullDark dark:border-green-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      :value="String(item.pui_bonus_quantity ?? 0)"
                      @input="onPurchaseLineBonusQtyLocaleInput($event, item)"
                      placeholder="0"
                      :title="$t('bonus_gift_items')"
                    />
                  </td>
                  <td class="px-2 py-2">
                    <input
                      type="text"
                      inputmode="decimal"
                      autocomplete="off"
                      class="w-24 bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      :value="purchaseLineDecimalInputValue(item.pui_cost_price)"
                      @input="onPurchaseLineCostLocaleInput($event, item)"
                    />
                  </td>
                  <td class="px-2 py-2">
                    <input
                      type="text"
                      inputmode="decimal"
                      autocomplete="off"
                      class="w-20 bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      :value="purchaseLineDecimalInputValue(item.pui_discount)"
                      @input="onPurchaseLineDiscountLocaleInput($event, item)"
                    />
                  </td>
                  <!--   <td class="px-2 py-2">
                    <input
                      type="number"
                      class="w-24 bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      v-model="item.pui_sale_price"
                      min="0"
                    />
                  </td> -->
                  <td class="px-2 py-2">
                    {{ formatNumber(item.pui_quantity * item.pui_cost_price - item.pui_discount) }}
                    <span v-if="item.pui_bonus_quantity > 0" class="text-green-600 dark:text-green-400 text-xs block">
                      +{{ item.pui_bonus_quantity }} {{ $t("free") }}
                    </span>
                    <span class="mx-1" v-show="cur_id == 1">{{
                      $t("dinar")
                    }}</span>
                    <span class="mx-1" v-show="cur_id == 2">{{
                      $t("dollar")
                    }}</span>
                  </td>
                  <td class="px-2 py-2 flex mt-2">
                    <button type="button" @click="removeItem(item.i_id)">
                      <i
                        class="fa-solid fa-trash text-center p-1 w-6 h-6 text-xs bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto my-auto"
                      ></i>
                    </button>
                  </td>
                </tr>
                <tr
                  class="bg-white text-textBlack border-b dark:bg-bgLightDark dark:text-textWhite2 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-bgFullDark"
                  v-show="purchase_items.length != 0"
                >
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2"></td>
                  <td class="px-2 py-2">
                    <div class="flex flex-col space-y-2">
                      <div class="flex items-center space-x-2">
                        <label
                          class="text-sm font-medium text-gray-700 dark:text-gray-300"
                        >
                          {{ $t("total_discount") }}:
                        </label>
                        <input
                          type="text"
                          inputmode="decimal"
                          autocomplete="off"
                          class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-20 p-1 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          :value="purchaseLineDecimalInputValue(total_discount)"
                          @input="onTotalDiscountLocaleInput"
                        />
                        <span class="text-xs" v-show="cur_id == 1">{{
                          $t("dinar")
                        }}</span>
                        <span class="text-xs" v-show="cur_id == 2">{{
                          $t("dollar")
                        }}</span>
                      </div>
                      <div class="flex items-center space-x-2">
                        <label
                          class="text-sm font-medium text-gray-700 dark:text-gray-300"
                        >
                          {{ $t("percentage_discount") }}:
                        </label>
                        <input
                          type="text"
                          inputmode="decimal"
                          autocomplete="off"
                          class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-16 p-1 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          :value="String(percentage_discount ?? 0)"
                          @input="onPercentageDiscountLocaleInput"
                        />
                        <span class="text-xs">%</span>
                      </div>
                    </div>
                  </td>
                  <td class="px-2 py-2">
                    {{ $t("total_price") }} : {{ formatNumber(sumPrice) }}
                    <span v-if="totalBonusItems > 0" class="text-green-600 dark:text-green-400 text-xs block">
                      {{ $t("total_bonus") }}: {{ totalBonusItems }}
                    </span>
                    <span class="mx-1" v-show="cur_id == 1">{{
                      $t("dinar")
                    }}</span>
                    <span class="mx-1" v-show="cur_id == 2">{{
                      $t("dollar")
                    }}</span>
                  </td>
                  <td class="px-2 py-2 flex mt-2"></td>
                </tr>
              </tbody>
            </table>
            <center>
              <span
                class="text-center text-textBlack1 dark:text-white"
                v-show="purchase_items.length == 0"
                >{{ $t("no_item_in_invoice") }}</span
              >
            </center>
          </div>
        </form>
      </div>
    </div>

    <div
      class="text-textBlack1 dark:text-white flex justify-between items-center px-4 md:px-16 py-3 left-0 right-0 fixed bottom-0 bg-white dark:bg-bgMeduimDark rounded-tl-xl z-50"
    >
      <div class="md:flex items-baseline my-3 lg:my-0">
        <p class="text-sm md:text-base">
          {{ $t("total_items_price") }} :
          <span class="text-xl md:text-2xl font-bold">{{
            formatNumber(sumPrice)
          }}</span>
          <span class="mx-1 font-bold text-lg" v-show="cur_id == 1">{{
            $t("dinar")
          }}</span>
          <span class="mx-1 font-bold text-lg" v-show="cur_id == 2">{{
            $t("dollar")
          }}</span>
        </p>

        <div class="flex mx-0 md:mx-6 items-center my-3 lg:my-0">
          <span
            class="text-sm md:text-base font-medium text-textBlack1 dark:text-textWhite1 mx-1"
            >{{ $t("paid_amount") }}:</span
          >
          <input
            type="text"
            inputmode="decimal"
            autocomplete="off"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 w-20 md:w-40 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
            :value="String(pu_paid_amount ?? 0)"
            @input="onRootDecimalLocaleInput($event, 'pu_paid_amount')"
          />
        </div>

        <p class="text-sm md:text-base mx-2">
          {{ $t("debt") }}:
          <span class="text-xl md:text-2xl font-bold">{{
            formatNumber(sumPrice - pu_paid_amount)
          }}</span>
          <span class="mx-1 font-bold text-lg" v-show="cur_id == 1">{{
            $t("dinar")
          }}</span>
          <span class="mx-1 font-bold text-lg" v-show="cur_id == 2">{{
            $t("dollar")
          }}</span>
        </p>
      </div>

      <div class="lg:flex">
        <button
          data-modal-target="defaultModal"
          data-modal-toggle="defaultModal"
          class="text-white text-lg md:text-xl bg-red-500 w-32 lg:w-40 my-2 lg:my-0 py-2 rounded items-center hover:shadow-md"
          @click="clearPurchase"
        >
          <i class="fa-solid fa-trash"></i>
        </button>
        <div class="w-2 md:w-4"></div>
        <button
          class="text-white text-lg md:text-xl bg-primaryColor w-32 lg:w-40 my-2 lg:my-0 py-2 rounded items-center hover:shadow-md"
          @click="addPurchase"
        >
          <div v-if="!isBtnLoading">{{ $t("purchase") }}</div>

          <div
            class="flex items-center hover:shadow-mdtext-white flex justify-center items-center hover:shadow-md"
            role="status"
            v-else
          >
            <svg
              width="20"
              height="20"
              fill="currentColor"
              class="mr-2 animate-spin"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"
              ></path>
            </svg>
            <span class="mx-1">{{ $t("wait") }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <div :class="classesPrintModal()">
    <!-- modal -->
    <div class="my_font bg-white rounded shadow-lg w-10/12 md:w-1/3">
      <!-- modal body -->
      <div
        class="p-3 bg-white my_font font-bold text-size-base text-black"
        id="invoice_print"
      >
        <div>
          <h6 class="text-center text-black font-bold text-size-lg">
            {{ settings.app_name }}
          </h6>
          <p class="my_font text-center font-bold text-size-base text-black">
            {{ settings.set_header_purchase }}
          </p>

          <p class="my_font text-center font-bold text-size-base text-black">
            <i
              class="fas fa-phone text-size-base relative mx-2 text-pink text-center"
            ></i>
            {{
              settings.set_phone_number +
              (settings.set_phone_number2 != "" &&
              settings.set_phone_number2 != null
                ? " - " + settings.set_phone_number2
                : "")
            }}
          </p>
          <p class="my_font text-center font-bold text-size-base text-black">
            <i
              class="fas fa-map-marker-alt text-size-base relative mx-2 text-pink text-center"
            ></i>
            {{ settings.set_address }}
          </p>
        </div>
        <div class="w-full max-w-full shrink-0 md:w-full md:flex-0 bg-white">
          <div class="flex-auto pb-2 my_font">
            <div class="overflow-x-auto">
              <table
                class="items-center w-full mb-0 align-top border-gray-200 text-black-500"
              >
                <tbody>
                  <tr v-if="pu_id != ''">
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("purchase_id") }}
                    </td>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ pu_id }}
                    </td>
                  </tr>
                  <tr v-if="su_id != ''">
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("suplier_name") }}
                    </td>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ getSuplierName(su_id) }}
                    </td>
                  </tr>
                  <tr v-if="pu_wasl_company != ''">
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("purchase_invoice_number") }}
                    </td>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ pu_wasl_company }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("date") }}
                    </td>
                    <td
                      class="text-black border border-black row-table-border font-bold px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      <!--
                                            show index of item in loop 1,2,3,4,5,6,7,8,9,10
                                          -->
                      <div class="whitespace-normal">
                        {{ Date().slice(0, 15) }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="flex-auto pb-2">
            <div class="overflow-x-auto">
              <table
                class="items-center w-full mb-0 align-top border-gray-200 text-black-500"
              >
                <thead class="align-bottom text-center">
                  <tr>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      #
                    </th>

                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      colspan="3"
                    >
                      {{ $t("item_name") }}
                    </th>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("cost") }}
                    </th>
                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("quantity") }}
                    </th>
                    <th
                      v-if="hasAnyBonus"
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("bonus") }}
                    </th>
                    <th
                      v-if="sumDiscount > 0"
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("discount") }}
                    </th>

                    <th
                      class="text-black text-right font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ $t("total") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="w-full"
                    v-for="(item, index) in purchase_items"
                    :key="index"
                  >
                    <td
                      class="text-black -bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ index + 1 }}
                    </td>

                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-normal dark:border-white/40"
                      colspan="3"
                    >
                      <div class="whitespace-normal">
                        {{ item.i_name }}
                      </div>
                    </td>
                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ formatNumber(item.pui_cost_price) }}
                    </td>
                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ formatNumber(item.pui_quantity) }}
                    </td>
                    <td
                      v-if="hasAnyBonus"
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      <span v-if="item.pui_bonus_quantity > 0">{{ formatNumber(item.pui_bonus_quantity) }}</span>
                      <span v-else>-</span>
                    </td>
                    <td
                      v-if="sumDiscount > 0"
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                    >
                      {{ formatNumber(item.pui_discount || 0) }}
                    </td>

                    <td
                      class="text-black font-bold border border-black row-table-border my_font p-2 font-bold align-middle text-size-base bg-transparent border-b whitespace-nowrap dark:border-white/40"
                      colspan="1"
                    >
                      {{
                        formatNumber(item.pui_quantity * item.pui_cost_price - (item.pui_discount || 0))
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div>
          <table
            class="items-center w-full mb-0 align-top border-gray-200 text-black-500"
          >
            <tbody>
              <tr>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ $t("items_price") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <p>
                    {{ formatNumber(sumPriceWithoutDiscount) }}
                  </p>
                </td>
              </tr>

              <tr v-if="sumDiscount > 0">
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ $t("discount") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <p>
                    {{ formatNumber(sumDiscount) }}
                  </p>
                </td>
              </tr>

              <tr>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ $t("final_price") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-lg my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ formatNumber(sumPrice) }}</b>
                </td>
              </tr>

              <tr>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ $t("debt") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-lg my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ formatNumber(sumPrice - pu_paid_amount) }}</b>
                </td>
              </tr>
              <tr>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-base my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ $t("paid_amount") }}</b>
                </td>
                <td
                  class="text-black border border-black row-table-border px-4 py-2 w-1/5 text-size-lg my_font p-2 align-middle bg-transparent border-b whitespace-nowrap dark:border-white/40"
                >
                  <b> {{ formatNumber(pu_paid_amount) }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="border-b w-full"></div>
      <div class="flex justify-start items-center w-full p-3 bg-white">
        <button
          class="mx-auto text-center bg-pink-600 hover:bg-pink-700 px-3 py-1 rounded text-white"
          @click="modalPrintID"
        >
          <svg
            aria-hidden="true"
            class="mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-pink-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="loading"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span v-if="!loading"> {{ $t("print") }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Calculator Modal -->
  <CalculatorModal 
    :isOpen="isCalculatorOpen" 
    @close="closeCalculator"
    @open-calculator="openCalculator"
  />
</template>
<script>
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { FILE_URL } from "../../constants/config";
import { CURRENCYS } from "../../constants/config";
import { formatNumber } from "../../utils/functions";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import { printInvoiceA4 } from "../../helpers/print";
import { i18n } from "../../main"; // Adjust the import path accordingly
import CalculatorModal from "../../components/Modals/CalculatorModal.vue";
import {
  sanitizeNumericInput,
  sanitizeIntegerInput,
  applyPercentageDecimalInput,
  applyRootDecimalLocaleInput,
  numericFromDecimalField,
  lineDecimalInputDisplay,
  processDecimalInputEvent,
} from "../../utils/localeDigits";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    BaseInput,

    ConfirmDialogue,
    ResultDialog,
    TextAreaInput,
    DropdownInput,
    CalculatorModal,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value || value == 0) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      no_rule: [],
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      isShowDetail: false,
      file_url: FILE_URL,
      currencys: CURRENCYS,
      purchase_items: [],
      barcode: "",
      pu_paid_amount: 0,
      pu_total_amount: 0,

      pu_due_amount: 0,
      su_id: "",
      bo_id: "",
      cur_id: 2,
      st_id: "",
      pu_main_currency_price: 0,
      pl_id: "",
      pu_note: "",
      created_at: "",
      pu_wasl_company: "",
      tempItem: 0,
      recivedMoney: 0,
      changeMoney: 0,
      in_type: 1,
      isPrint: "2",
      isModalPrint: false,
      pu_id: "",
      settings: {},
      isShowItemsCategorys: true,
      isShowCategories: true,
      isShowItems: true,
      beforeDebtIQD: 0,
      beforeDebtUSD: 0,
      isShowDebts: false,
      total_discount: 0,
      percentage_discount: 0,
      lastAddedItemId: null,
    };
  },
  created() {
    this.settings = JSON.parse(
      localStorage.getItem("currentSettingWiseManager")
    );
    this.getBoxs();
    this.$store.dispatch("item_category/getCategory");
    this.getPosData();

    this.getSupliers();

    this.$store.dispatch("navbar/getItems");
    
    // Initialize dollar price with current value from store
    this.pu_main_currency_price = this.getDolarPrice;
  },
  mounted() {
    // Initialize dollar price after component is mounted and store is loaded
    if (this.pu_main_currency_price === 0 && this.getDolarPrice) {
      this.pu_main_currency_price = this.getDolarPrice;
    }
    window.addEventListener("keydown", this.handleGlobalQtyArrowKeys);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleGlobalQtyArrowKeys);
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.new_purchase.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.new_purchase.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("new_purchase/SET_DELETE_SUCCESS", false);
      }
    },
    // Watch for dollar price changes in store
    getDolarPrice(newValue) {
      if (this.pu_main_currency_price === 0 && newValue) {
        this.pu_main_currency_price = newValue;
      }
    },
    isCalculatorOpen: false,
  },

  computed: {
    getChangeMoney() {
      return this.recivedMoney - this.pu_paid_amount;
    },
    getDue() {
      return this.sumPrice - this.pu_paid_amount;
    },
    getResultDialog() {
      return this.$store.state.new_purchase.isShowResultDialog;
    },
    getDolarPrice() {
      return this.$store.state.navbar.dp_price;
    },
    filterItems() {
      return this.$store.getters["new_purchase/filterItems"];
    },
    filterItemsPos() {
      return this.$store.getters["new_purchase/filterItemsPOS"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.new_purchase.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.new_purchase.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.new_purchase.isBtnEditLoading;
    },

    convertToListIdValueCategory() {
      var categorys = this.$store.state.item_category.categorys;
      var list = [];
      for (const item of categorys) {
        list.push({
          id: item.ca_id,
          value: item.ca_name,
        });
      }

      return list;
    },
    convertToListIdValueBoxes() {
      var boxes = this.$store.state.all_box.boxes;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.bo_id,
          value: item.bo_name,
        });
      }

      return list;
    },

    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueSupliers() {
      var supliers = this.$store.state.suplier.supliers;
      var list = [];
      for (const item of supliers) {
        list.push({
          id: item.su_id,
          value: item.su_name,
        });
      }

      return list;
    },

    //sum price of all items
    sumDiscount() {
      var sum = 0;
      for (const item of this.purchase_items) {
        sum += item.pui_discount || 0;
      }
      return Math.round(sum);
    },
    sumPriceWithoutDiscount() {
      var sum = 0;
      for (const item of this.purchase_items) {
        sum += item.pui_cost_price * item.pui_quantity;
      }
      return sum.toFixed(5);
    },
    sumPrice() {
      var sum = 0;
      for (const item of this.purchase_items) {
        sum += item.pui_cost_price * item.pui_quantity - (item.pui_discount || 0);
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.pu_paid_amount = sum.toFixed(5);
      return sum.toFixed(5);
    },
    sumCost() {
      var sum = 0;
      for (const item of this.purchase_items) {
        sum += item.pui_cost_price * item.pui_quantity;
      }
      return sum.toFixed(5);
    },
    totalBonusItems() {
      var sum = 0;
      for (const item of this.purchase_items) {
        sum += parseInt(item.pui_bonus_quantity || 0);
      }
      return sum;
    },
    hasAnyBonus() {
      return this.purchase_items.some(item => item.pui_bonus_quantity > 0);
    },
  },

  methods: {
    purchaseLineDecimalInputValue(value) {
      return lineDecimalInputDisplay(value);
    },
    onPurchaseLineQtyLocaleInput(e, item) {
      const next = sanitizeIntegerInput(e.target.value);
      if (e.target.value !== next) e.target.value = next;
      const n = parseInt(next, 10);
      item.pui_quantity = next === "" ? 0 : (Number.isFinite(n) ? Math.max(0, n) : 0);
      this.calculateDue(item, item.pui_quantity);
    },
    onPurchaseLineBonusQtyLocaleInput(e, item) {
      const next = sanitizeIntegerInput(e.target.value);
      if (e.target.value !== next) e.target.value = next;
      const n = parseInt(next, 10);
      item.pui_bonus_quantity = next === "" ? 0 : (Number.isFinite(n) ? Math.max(0, n) : 0);
    },
    onPurchaseLineCostLocaleInput(e, item) {
      item.pui_cost_price = processDecimalInputEvent(e, "");
    },
    onPurchaseLineDiscountLocaleInput(e, item) {
      item.pui_discount = processDecimalInputEvent(e, 0);
      this.calculateDis(item, numericFromDecimalField(item.pui_discount, 0));
    },
    onRootDecimalLocaleInput(e, key, afterCallback) {
      const stored = processDecimalInputEvent(e, 0);
      this[key] = stored;
      if (typeof afterCallback === "function" && typeof stored === "number") {
        afterCallback.call(this);
      }
    },
    onTotalDiscountLocaleInput(e) {
      const next = sanitizeNumericInput(e.target.value);
      if (e.target.value !== next) {
        e.target.value = next;
      }
      this.total_discount = applyRootDecimalLocaleInput(next, 0);
      const display = this.purchaseLineDecimalInputValue(this.total_discount);
      if (e.target.value !== display) {
        e.target.value = display;
      }
      if (typeof this.total_discount === "number") {
        this.applyTotalDiscount();
      }
    },
    onPercentageDiscountLocaleInput(e) {
      const next = sanitizeNumericInput(e.target.value);
      if (e.target.value !== next) e.target.value = next;
      this.percentage_discount = applyPercentageDecimalInput(next);
      if (typeof this.percentage_discount === "number") {
        this.applyPercentageDiscount();
      }
    },
    handleGlobalQtyArrowKeys(event) {
      if (event.key !== "ArrowUp" && event.key !== "ArrowDown") {
        return;
      }
      if (!this.purchase_items || this.purchase_items.length === 0) {
        return;
      }
      const lastItem =
        this.purchase_items.find((item) => item.i_id === this.lastAddedItemId) ||
        this.purchase_items[this.purchase_items.length - 1];
      if (!lastItem) return;

      event.preventDefault();
      event.stopPropagation();

      const currentQty = Number(lastItem.pui_quantity) || 1;
      const delta = event.key === "ArrowUp" ? 1 : -1;
      const minQty = 1;
      const nextQty = Math.max(minQty, currentQty + delta);
      if (nextQty !== currentQty) {
        this.updatePurchase(lastItem, nextQty);
      }
    },
    getTableColumns() {
      let columns = ["#", "item_name", "cost", "quantity"];
      if (this.hasAnyBonus) {
        columns.push("bonus");
      }
      if (this.sumDiscount > 0) {
        columns.push("discount");
      }
      columns.push("total_price");
      return columns;
    },
    handleSearchInput(value) {
      this.$store.commit('new_purchase/SET_SEARCH_POS', value);
    },
    openCalculator() {
      this.isCalculatorOpen = true;  this.$nextTick(() => {
        // Force re-render if needed
        this.$forceUpdate();
      });
    },
    closeCalculator() {
       this.isCalculatorOpen = false;
      this.$nextTick(() => {
        // Force re-render if needed
        this.$forceUpdate();
      });
    },
    async getSuplierDebt() {
      this.isShowDebts = false;
      var res = await this.$store.dispatch("suplier/getCurrentDebt", {
        su_id: this.su_id,
        //this year till end
        created_at: new Date().getFullYear() + "-12-31",
      });

      this.beforeDebtIQD = res.balance_before_date.IQD;
      this.beforeDebtUSD = res.balance_before_date.USD;
      this.isShowDebts = true;
    },
    getSuplierName(su_id) {
      var supliers = this.$store.state.suplier.supliers;
      for (const item of supliers) {
        if (item.su_id == su_id) {
          return item.su_name;
        }
      }
    },
    async modalPrintA4() {
      //proccess purchase_items to send to printInvoiceA4 get name by id and others put to new array
      var itemsToprint = this.purchase_items.map((item) => {
        var itemData = {
          i_id: item.i_id,
          item_name: item.i_name,
          cost: this.formatNumber(item.pui_cost_price),
          quantity: this.formatNumber(item.pui_quantity),
          total_price: this.formatNumber(
            item.pui_cost_price * item.pui_quantity - (item.pui_discount || 0)
          ),
        };
        
        // Only add bonus field if any item has bonus
        if (this.hasAnyBonus) {
          itemData.bonus = item.pui_bonus_quantity > 0 ? this.formatNumber(item.pui_bonus_quantity) : '-';
        }
        
        // Only add discount field if any item has discount
        if (this.sumDiscount > 0) {
          itemData.discount = this.formatNumber(item.pui_discount || 0);
        }
        
        return itemData;
      });
      var res = await this.$store.dispatch("suplier/getCurrentDebt", {
        su_id: this.su_id,
        //invoice date
        created_at: this.created_at,
      });

      var beforeDebtIQD = res.balance_before_date.IQD;
      var beforeDebtUSD = res.balance_before_date.USD;
      //balance_up_to_and_including_date
      var balanceUpToAndIncludingDateIQD =
        res.balance_up_to_and_including_date.IQD;
      var balanceUpToAndIncludingDateUSD =
        res.balance_up_to_and_including_date.USD;
      const sampleData = {
        invoiceTitle: this.settings.set_header_purchase,
        invoiceId: this.pu_id,
        name: this.su_id != "" ? this.getSuplierName(this.su_id) : "",
        name_var: "suplier_name",
        number_wasl: this.pu_wasl_company,
        number_wasl_var: "purchase_invoice_number",
        id: this.su_id,
        invoiceDate: this.formatDate(this.created_at),
        headerMessage: this.settings.set_header_purchase,
        beforeDebtIQD: beforeDebtIQD,
        beforeDebtUSD: beforeDebtUSD,
        balanceUpToAndIncludingDateIQD: balanceUpToAndIncludingDateIQD,
        balanceUpToAndIncludingDateUSD: balanceUpToAndIncludingDateUSD,
        currency: this.cur_id == 1 ? this.$t("dinar") : this.$t("dollar"),
        companyInfo: {
          appName: this.settings.app_name,
          phoneNumber: this.settings.set_phone_number,
          phoneNumber2: this.settings.set_phone_number2,
          logoUrl: this.file_url + this.settings.set_logo,
          address: this.settings.set_address,
        },
        tableColumns: this.getTableColumns(),
        items: itemsToprint,
        note: this.pu_note,
        summary: {
          itemsPrice: this.sumPriceWithoutDiscount,
          discount: this.sumDiscount > 0 ? this.sumDiscount : null,
          paidAmount: this.pu_paid_amount,
          debt: this.getDue,
          currency: this.cur_id == 1 ? this.$t("dinar") : this.$t("dollar"),
          finalPrice: this.sumPrice,
        },
      };
      const t = i18n.global.t;

      printInvoiceA4(sampleData, this.formatNumber, t);
      this.$store.state.new_purchase.isBtnLoading = false;
      this.isSubmited = false;
      this.getPosData();
      this.clearPurchase(false);
    },
    modalPrintID() {
      this.isModalPrint = !this.isModalPrint;

      // Get the content to print
      const printContents = document.getElementById("invoice_print").innerHTML;

      // Open a new window for printing
      const printWindow = window.open("", "_blank");
      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.16/dist/tailwind.min.css" rel="stylesheet">
        <style>
          /* Set the RTL direction */
          body {
            direction: rtl;
            font-family: 'Rabar_022', sans-serif; /* Use the font name you define here */
          }
        </style>
        <link rel="stylesheet" href="https://kcstore.online/fonts/Rabar_022.6835fa5e.ttf">
      </head>
      <body>
        <div >
          ${printContents}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      // Print the contents
      printWindow.print();

      //
      printWindow.document.close();

      // Print the contents
      printWindow.print();

      // Close the print window after printing

      this.isModalPrint = !this.isModalPrint;
    },
    classesPrintModal() {
      return {
        "modal  bg-opacity-5 h-full   w-full  fixed top-0 left-0  justify-center   hidden overflow-y-auto":
          !this.isModalPrint,
        "modal  bg-opacity-5 h-full   w-full  fixed top-0 left-0  justify-center  flex overflow-y-auto ":
          this.isModalPrint,
      };
    },
    printStatus() {},
    getPosData() {
      this.$store.dispatch("new_purchase/getItemsPOS", {
        in_type: this.in_type,
      });
    },
    changeCurrencyType() {
      if (this.cur_id == 1) {
        this.cur_id = 2;
      } else {
        this.cur_id = 1;
      }
    },

    async getSupliers() {
      await this.$store.dispatch("suplier/getSupliers");

      this.su_id = this.$store.state.suplier.supliers[0].su_id;
      this.getSuplierDebt();
    },

    async getBoxs() {
      await this.$store.dispatch("all_box/getBoxes");

      this.bo_id = this.$store.state.all_box.boxes[0].bo_id;
    },

    formatNumber(number) {
      return formatNumber(number);
    },
    formatDate(date) {
      return formatDate(date);
    },
    calculateDue(item, num) {
      this.updatePurchase(item, num);
    },
    calculateDis(item, discount) {
      this.updatePurchaseDiscount(item, discount);
    },
    updatePurchaseDiscount(item, discount) {
      for (const purchaseItem of this.purchase_items) {
        if (purchaseItem.i_id == item.i_id) {
          purchaseItem.pui_discount = discount;
          break;
        }
      }
      this.purchase_items = [...this.purchase_items];
    },
    applyTotalDiscount() {
      if (this.purchase_items.length === 0) {
        return;
      }

      const totalDiscount = numericFromDecimalField(this.total_discount, 0);

      // Clear percentage discount when using total discount
      this.percentage_discount = 0;

      // If total discount is 0 or negative, clear all item discounts
      if (totalDiscount <= 0) {
        for (const item of this.purchase_items) {
          item.pui_discount = 0;
        }
        this.purchase_items = [...this.purchase_items];
        return;
      }

      // Calculate total price without discount
      let totalPriceWithoutDiscount = 0;
      for (const item of this.purchase_items) {
        totalPriceWithoutDiscount += item.pui_cost_price * item.pui_quantity;
      }

      if (totalDiscount > totalPriceWithoutDiscount) {
        this.$refs.ResultDialog.show({
          message: this.$t("discount_more_than_total_price"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        this.total_discount = 0;
        return;
      }

      // Distribute the total discount proportionally among items
      let totalCalculatedDiscount = 0;
      for (const item of this.purchase_items) {
        const itemPrice = item.pui_cost_price * item.pui_quantity;
        const proportionalDiscount =
          (itemPrice / totalPriceWithoutDiscount) * totalDiscount;
        item.pui_discount = Math.round(proportionalDiscount * 100000) / 100000;
        totalCalculatedDiscount += item.pui_discount;
      }

      // Adjust the last item's discount to ensure total discount equals the desired amount
      if (this.purchase_items.length > 0) {
        const difference = totalDiscount - totalCalculatedDiscount;
        const lastItem = this.purchase_items[this.purchase_items.length - 1];
        lastItem.pui_discount =
          Math.round((lastItem.pui_discount + difference) * 100000) / 100000;
      }

      this.purchase_items = [...this.purchase_items];
    },
    applyPercentageDiscount() {
      if (this.purchase_items.length === 0) {
        return;
      }

      // Clear total discount when using percentage discount
      this.total_discount = 0;

      // If percentage discount is 0 or negative, clear all item discounts
      if (this.percentage_discount <= 0) {
        for (const item of this.purchase_items) {
          item.pui_discount = 0;
        }
        this.purchase_items = [...this.purchase_items];
        return;
      }

      // Validate percentage range
      if (this.percentage_discount > 100) {
        this.$refs.ResultDialog.show({
          message: this.$t("percentage_discount_cannot_exceed_100"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        this.percentage_discount = 0;
        return;
      }

      // Apply percentage discount to each item
      let totalCalculatedDiscount = 0;
      for (const item of this.purchase_items) {
        const itemPrice = item.pui_cost_price * item.pui_quantity;
        const discountAmount = (itemPrice * this.percentage_discount) / 100;
        item.pui_discount = Math.round(discountAmount * 100000) / 100000;
        totalCalculatedDiscount += item.pui_discount;
      }

      // Round the total discount to a whole number and adjust the last item
      const roundedTotalDiscount = Math.round(totalCalculatedDiscount);
      if (
        this.purchase_items.length > 0 &&
        roundedTotalDiscount !== totalCalculatedDiscount
      ) {
        const difference = roundedTotalDiscount - totalCalculatedDiscount;
        const lastItem = this.purchase_items[this.purchase_items.length - 1];
        lastItem.pui_discount =
          Math.round((lastItem.pui_discount + difference) * 100000) / 100000;
      }

      this.purchase_items = [...this.purchase_items];
    },
    recalculateDiscounts() {
      // Recalculate discounts when cart changes
      if (typeof this.total_discount === "number" && this.total_discount > 0) {
        this.applyTotalDiscount();
      } else if (this.percentage_discount > 0) {
        this.applyPercentageDiscount();
      }
    },
    async addPurchase() {
      if (this.$store.state.new_purchase.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.bo_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.su_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.cur_id, "add", this.rules).isError ||
        this.checkRulesIsError(this.pu_paid_amount, "add", this.rules)
          .isError ||
        this.checkRulesIsError(this.sumPrice, "add", this.rules).isError ||
        this.checkRulesIsError(this.sumDiscount, "add", this.rules).isError ||
        this.checkRulesIsError(this.getDue, "add", this.rules).isError ||
        this.checkRulesIsError(this.pu_main_currency_price, "add", this.rules).isError ||
        this.checkRulesIsError(this.sumCost, "add", this.rules).isError
      ) {
        this.$refs.ResultDialog.show({
          message: this.$t("please_fill_all_fields"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }
      //check if in paid > in price
      if (this.pu_paid_amount > this.sumPrice) {
        this.$refs.ResultDialog.show({
          message: this.$t("paid_money_more_than_total_price"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }

      if (
        isNaN(this.pu_paid_amount) ||
        isNaN(this.pu_total_amount) ||
        isNaN(this.pu_due_amount) ||
        this.pu_paid_amount < 0 ||
        this.pu_total_amount < 0 ||
        this.pu_due_amount < 0
      ) {
        this.$refs.ResultDialog.show({
          message: this.$t("please_enter_valid_number_for_all_fields"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }

      if (this.purchase_items.length == 0) {
        this.$refs.ResultDialog.show({
          message: this.$t("no_item_in_invoice"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
        return;
      }
      this.$store.state.new_purchase.isBtnLoading = true;
      var tempPurchaseList = [];
      for (const item of this.purchase_items) {
        //check pui_cost_price
        if (
          item.pui_cost_price == "" ||
          item.pui_cost_price == 0 ||
          item.pui_cost_price == null
        ) {
          this.$refs.ResultDialog.show({
            message: this.$t("please_fill_cost_field_of_all_purchased_items"),
            okButton: this.$t("done"),
            isSuccess: false,
          });
          this.$store.state.new_purchase.isBtnLoading = false;
          return;
        }
        /*   if (item.pui_sale_price == "") {
          this.$refs.ResultDialog.show({
            message: this.$t("please_fill_sale_field_of_all_purchased_items"),
            okButton: this.$t("done"),
            isSuccess: false,
          });
          return;
        }*/
        tempPurchaseList.push({
          i_id: item.i_id,
          i_barcode: item.i_barcode,
          pui_quantity: item.pui_quantity,
          pui_bonus_quantity: item.pui_bonus_quantity || 0,
          pui_discount: item.pui_discount || 0,
          cur_id: this.cur_id,
          pui_sale_price: item.pui_sale_price,

          // pui_sale_price_jwmla: item.pui_sale_price_jwmla,
          pui_cost_price: item.pui_cost_price,
        });
      }

      var res = await this.$store.dispatch("new_purchase/addNewItem", {
        su_id: this.su_id,
        bo_id: this.bo_id,
        cur_id: this.cur_id,

        pu_paid_amount: this.pu_paid_amount,
        pu_total_amount: this.sumPrice,
        pu_discount: this.sumDiscount,
        in_cost: this.sumCost,

        pu_due_amount: this.getDue,
        pu_main_currency_price: this.pu_main_currency_price,
        pu_note: this.pu_note,
        purchase_items: tempPurchaseList,
        created_at: this.created_at,
        pu_wasl_company: this.pu_wasl_company,
        in_type: this.in_type,
      });

      if (res.status == 200) {
        //this.isSubmited = false;
        //  this.getPosData();
        this.pu_id = res.data.pu_id;
        this.created_at = res.data.created_at;
        await new Promise((r) => setTimeout(r, 1000));
        if (this.isPrint == "1" || this.isPrint == "3") {
          //wait 0.5 second

          if (this.isPrint == "1") {
            this.modalPrintID();
          } else if (this.isPrint == "3") {
            this.modalPrintA4();
          }
        }

        this.$store.dispatch("navbar/getItems");

        if (this.isPrint == "2" || this.isPrint == "1") {
          this.getPosData();
          this.clearPurchase(false);
        }
      }
      if (this.isPrint == "1" || this.isPrint == "2") {
        this.$store.state.new_purchase.isBtnLoading = false;
        this.isSubmited = false;
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    addRecievedMoney(curency, amount) {
      //check this.cur_id == curency.cur_id
      if (this.cur_id == curency) {
        this.recivedMoney += amount;
      } else {
        if (this.cur_id == 1) {
          //convert to dinar
          this.recivedMoney += amount * this.getDolarPrice;
        } else {
          //convert to dollar
          this.recivedMoney += amount / this.getDolarPrice;
        }
      }
    },
    clearPurchase() {
      this.purchase_items = [];
      this.pu_paid_amount = 0;
      this.pu_total_amount = 0;

      this.pu_due_amount = 0;
      this.pu_main_currency_price = this.getDolarPrice;
      this.pu_note = "";
      this.created_at = "";
      this.pu_wasl_company = "";
      this.recivedMoney = 0;
      this.total_discount = 0;
      this.percentage_discount = 0;
    },

    addItemToPurchase(item) {
      //check if item is already in the list

      var isExist = false;
      for (const purchaseItem of this.purchase_items) {
        if (purchaseItem.i_id == item.i_id) {
          isExist = true;

          purchaseItem.pui_quantity++;
          break;
        }
      }
      if (isExist == false) {
        var obj = {
          i_barcode: item.i_barcode,
          i_id: item.i_id,
          cur_id: item.cur_id,
          pui_quantity: 1,
          pui_bonus_quantity: 0,
          pui_discount: 0,
          //   pui_sale_price: "",
          //   pui_sale_price_jwmla: "",
          pui_cost_price: "",

          i_name: item.i_name,
          un_name: item.unit.un_name,

          i_quantity: item.i_quantity,
        };
        this.purchase_items.push(obj);
      } else {
        this.purchase_items = [...this.purchase_items];
      }
      
      // Recalculate discounts when item is added
      this.recalculateDiscounts();

      // Set last added item ID for ArrowUp/ArrowDown control
      this.lastAddedItemId = item.i_id;
    },
    //removeItem

    updatePurchase(item, num) {
      for (const purchaseItem of this.purchase_items) {
        if (purchaseItem.i_id == item.i_id) {
          purchaseItem.pui_quantity = num;
          break;
        }
      }

      this.purchase_items = [...this.purchase_items];
    },
    checkHowMuchItemInCard(i_id) {
      for (const item of this.purchase_items) {
        if (item.i_id == i_id) {
          return item.pui_quantity;
        }
      }
      return 0;
    },
    removeItem(i_id) {
      for (const item of this.purchase_items) {
        if (item.i_id == i_id) {
          this.purchase_items.splice(this.purchase_items.indexOf(item), 1);
          break;
        }
      }
      
      // Recalculate discounts when item is removed
      this.recalculateDiscounts();
    },
    enterBarcode(e) {
      e.preventDefault();
      if (this.barcode == "") return;
      var item = this.filterItemsPos.find(
        (item) => item.i_barcode == this.barcode
      );
      if (item) {
        this.addItemToPurchase(item);
        this.barcode = "";
      } else {
        this.$refs.ResultDialog.show({
          message: this.$t("item_not_found_for_this_barcode"),
          okButton: this.$t("done"),
          isSuccess: false,
        });
      }
    },
  },
};
</script>
